import React, { useState } from 'react';
import {
  Button,
  ButtonGroup,
  Input,
  Label,
  Row,
  Col,
  FormGroup
} from 'reactstrap';
import { formatDateForAPI, getDateRangePresets } from '../utils/formatters';

const DateRangePicker = ({ onRangeChange, defaultRange = 'Last 90 Days' }) => {
  const presets = getDateRangePresets();
  const [activePreset, setActivePreset] = useState(defaultRange);
  const [customFrom, setCustomFrom] = useState('');
  const [customTo, setCustomTo] = useState('');

  const handlePresetClick = (presetName) => {
    setActivePreset(presetName);
    const range = presets[presetName];
    onRangeChange({
      from: formatDateForAPI(range.from),
      to: formatDateForAPI(range.to)
    });
  };

  const handleCustomRange = () => {
    if (customFrom && customTo) {
      setActivePreset(null);
      onRangeChange({
        from: customFrom,
        to: customTo
      });
    }
  };

  return (
    <div className="mb-4">
      <Row>
        <Col md={8}>
          <Label>Quick Select:</Label>
          <ButtonGroup className="d-flex flex-wrap">
            {Object.keys(presets).map(presetName => (
              <Button
                key={presetName}
                size="sm"
                color={activePreset === presetName ? 'primary' : 'outline-primary'}
                onClick={() => handlePresetClick(presetName)}
                className="mb-2"
              >
                {presetName}
              </Button>
            ))}
          </ButtonGroup>
        </Col>
        <Col md={4}>
          <Label>Custom Range:</Label>
          <FormGroup>
            <Input
              type="date"
              size="sm"
              value={customFrom}
              onChange={(e) => setCustomFrom(e.target.value)}
              className="mb-2"
            />
            <Input
              type="date"
              size="sm"
              value={customTo}
              onChange={(e) => setCustomTo(e.target.value)}
              className="mb-2"
            />
            <Button
              size="sm"
              color="success"
              block
              onClick={handleCustomRange}
              disabled={!customFrom || !customTo}
            >
              Apply Custom Range
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};

export default DateRangePicker;
